import { Checkbox, FormControlLabel } from "@mui/material";

interface InvoiceCheckboxProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  label?: string;
}

/**
 * Komponent checkboxa dla faktury
 * Zgodny z zasadą pojedynczej odpowiedzialności - tylko checkbox
 */
export default function InvoiceCheckbox({
  checked,
  onChange,
  disabled = false,
  label = "Chcę otrzymać fakturę",
}: InvoiceCheckboxProps) {
  return (
    <FormControlLabel
      control={
        <Checkbox
          size="small"
          checked={checked}
          onChange={onChange}
          name="isInvoiceNeeded"
          disabled={disabled}
        />
      }
      label={label}
      sx={{
        "& .MuiFormControlLabel-label": {
          fontSize: "0.875rem",
        },
      }}
    />
  );
}
